const documentStatus = {
  COMPLETED: "completed",
  READY_TO_ASSIGN: "ready_to_assign",
};

module.exports = {documentStatus};
